import React, { useContext, useEffect, useState } from "react";
import { Modal, Button, Typography } from "@mui/material";
import Stepper from "react-stepper-horizontal";
import axios from "axios";
import config from "../../config/config";
import { useNavigate, useParams } from "react-router-dom";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../common/Constant";
import { toastError, toastSuccess, toastWarn } from "../../common/Toast";
import { AppContext } from "../../context/AppContext";

const PaybillsSteppermodal = (
  previosdata,
  fileddata,
  receivedata,
  handleOpenExternal
) => {
  console.log(previosdata, "410514");

  const token = localStorage.getItem("Token");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [previousid, setpreviousid] = useState(0);
  const [RollBackId, setRollBackId] = useState(0);
  let navigate = useNavigate();

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    if (activeStep === steps.length - 1 || activeStep === 0) {
      setOpen(false);
      setActiveStep(0);
      // window.location.reload()
      if (previosdata.fileddata == "saveandclose") {
        // navigate("/transaction-log");
        navigate(-1);
        setTimeout(() => {
          window.location.reload();
        }, 0);
      } else {
        navigate("/receiving-paybills");
        window.location.reload();
      }
    }
  };

  const callApiForStep = async (step) => {
    setLoading(true);
    try {
      if (step === 0) {
        const res = await axios.post(
          `${config.salesconfigBaseUrl}/receivings/receivingpaybillupsert_V2`,
          previosdata?.receivedata,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        );

        if (res.data.ResponseCode === "SUCCESS") {
          setpreviousid(res.data.ResponseID);
          setRollBackId(res.data.ResponseData);
          toastSuccess(SUCCESS_MESSAGE);
          setActiveStep((prevActiveStep) =>
            Math.min(prevActiveStep + 1, steps.length - 1)
          );
        } else {
          toastError(res.data.ResponseMessage);
          setOpen(false);
          setActiveStep(0);
          //  window.location.reload();
        }
      } else if (step === 1 && QBpermission) {
        const res = await axios.post(
          `${config.salesconfigBaseUrl}/receivings/paybillupsert_Quickbooks`,
          {
            ...previosdata?.receivedata,
            previousid: previousid,
            RollBackId: RollBackId,
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        );

        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          setActiveStep((prevActiveStep) =>
            Math.min(prevActiveStep + 1, steps.length - 1)
          );
        } else {
          toastError(ERROR_MESSAGE);
          //  resposeIds(res.data.ResponseData);
          setOpen(false);
          setActiveStep(0);
          await new Promise((resolve) => setTimeout(resolve, 500));
          if (res.data.ResponseData.length > 0) {
            navigate("/RecevingPaymentSync");
          } else {
            window.location.reload();
          }
        }
      }
    } catch (error) {
      console.error("Error during API call:", error);
      // alert("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      callApiForStep(activeStep);
    }
  };

  const [QBpermission, setqbpermission] = useState(true);

  const handlepermission = () => {
    axios
      .get(`${config.salesconfigBaseUrl}/receivings/BillPaymentPermission`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log(res.data.ResponseData[0].AppConfigvalue, "123");
        if (res.data.ResponseData[0].AppConfigvalue == "false") {
          setqbpermission(false);
        } else {
          setqbpermission(true);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    handlepermission();
  }, []);

  const steps = QBpermission
    ? ["Bill Payment", "Quickbook Sync", "Completed"]
    : ["Bill Payment", "Completed"];

  useEffect(() => {
    if (previosdata?.handleOpenExternal) {
      previosdata?.handleOpenExternal(() => handleOpen());
    }
  }, [previosdata?.handleOpenExternal]);

  return (
    <>
      <div>
        <Modal open={open} onClose={handleClose}>
          <div
            style={{
              padding: "20px",
              textAlign: "center",
              width: "400px",
              margin: "auto",
              top: "50%",
              transform: "translateY(-50%)",
              position: "relative",
              backgroundColor: "white",
            }}
          >
            <Typography variant="h6">Progress Stepper</Typography>
            <Stepper
              steps={steps.map((step) => ({ title: step }))}
              activeStep={activeStep}
            />
            <div style={{ marginTop: "20px" }}>
              {activeStep === steps.length - 1 ? (
                <Typography variant="body1">All steps completed!</Typography>
              ) : (
                <div>
                  <Typography variant="body1">
                    Current Step: {steps[activeStep]}
                  </Typography>
                  <Button
                    className="btn  btn-primary"
                    onClick={handleNext}
                    disabled={loading}
                    sx={{ margin: "5px", backgroundColor: "#1a2649" }}
                    variant="contained"
                  >
                    {loading ? "Loading..." : "Next"}
                  </Button>
                  {activeStep === 0 && (
                    <Button
                      variant="contained"
                      className="btn  btn-primary"
                      onClick={handleClose}
                      sx={{ margin: "5px", backgroundColor: "#1a2649" }}
                    >
                      Close
                    </Button>
                  )}
                </div>
              )}
            </div>
            {activeStep === steps.length - 1 && (
              <Button
                variant="outlined"
                className="btn btn-primary"
                sx={{
                  margin: "5px",
                  backgroundColor: "#1a2649",
                  color: "white",
                }}
                onClick={handleClose}
              >
                Close
              </Button>
            )}
          </div>
        </Modal>
      </div>
    </>
  );
};

export default PaybillsSteppermodal;
